import { render, staticRenderFns } from "./MypageUserConfirmPane.vue?vue&type=template&id=35aa8e55&scoped=true"
import script from "./MypageUserConfirmPane.vue?vue&type=script&lang=ts"
export * from "./MypageUserConfirmPane.vue?vue&type=script&lang=ts"
import style0 from "./MypageUserConfirmPane.vue?vue&type=style&index=0&id=35aa8e55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35aa8e55",
  null
  
)

export default component.exports